import { isString, isObject, isBoolean, isFunction, isArray } from './is';
function obj2qs(obj, remove) {
    let removeTest;
    if (isFunction(remove)) {
        removeTest = val => remove(val);
    }
    else if (isArray(remove)) {
        removeTest = val => remove.includes(val);
    }
    else {
        removeTest = (val) => false;
    }
    return Object.keys(obj)
        .reduce((qsArray, el) => {
        const val = obj[el];
        if (!removeTest(val)) {
            qsArray.push(`${el}=${encodeURIComponent(val)}`);
        }
        return qsArray;
    }, [])
        .join('&');
}
function getOneParams(url, key) {
    let param = null;
    const hasQ = url.indexOf('?') > -1;
    if (key && hasQ) {
        const re = new RegExp('[?|&]' + key + '=([^&;]+?)(&|#|;|$)');
        const exec = re.exec(url);
        if (exec) {
            param = exec[1].replace(/\+/g, '%20');
        }
    }
    return param;
}
function getAllParams(url) {
    const res = {};
    const hasQ = url.indexOf('?') > -1;
    if (hasQ) {
        const reg = /([^?&=]+)=([^?&=#]*)/g;
        url.replace(reg, (rs, $1, $2) => {
            const name = decodeURIComponent($1);
            const val = decodeURIComponent($2);
            res[name] = val;
            return rs;
        });
    }
    return res;
}
function getParams(url, key) {
    if (isString(url) && key !== '') {
        return getOneParams(url, key);
    }
    return getAllParams(url);
}
function getInsertPosition(url, afterHash) {
    if (isBoolean(afterHash)) {
        return afterHash;
    }
    return /^[^#?]+#[^?#]{0,}?\?[^?#]{0,}/.test(url);
}
function emptyQuery(url) {
    let _url = url;
    const re = /\?([^?#]+)(#|$)/g;
    while (re.test(_url)) {
        _url = _url.replace(re, '$2');
    }
    return _url;
}
function copyAndStringify(paramsObj) {
    const o = {};
    for (const key in paramsObj) {
        if (paramsObj.hasOwnProperty(key)) {
            let element = paramsObj[key];
            if (isFunction(element)) {
                continue;
            }
            if (isArray(element) || isObject(element)) {
                element = JSON.stringify(element);
            }
            o[key] = element;
        }
    }
    return o;
}
function pendParams(url, paramsObj, { afterHash, merge, rebuild, remove }) {
    let handleURL = url;
    const insertPosition = getInsertPosition(url, afterHash);
    let handleParams = copyAndStringify(paramsObj);
    if (!!merge) {
        Object.keys(handleParams).forEach(key => {
            const re = new RegExp(key + '=([^?&=#]*)');
            if (re.test(url)) {
                handleURL = handleURL.replace(re, `${key}=${encodeURIComponent(handleParams[key])}`);
                delete handleParams[key];
            }
        });
    }
    let qs = obj2qs(handleParams, remove);
    if (rebuild) {
        const allParams = getAllParams(handleURL);
        const allQs = obj2qs(allParams, remove);
        qs = [allQs, qs].filter(e => !!e).join('&');
        handleURL = emptyQuery(handleURL);
    }
    if (!qs) {
        return handleURL;
    }
    const Qindex = handleURL.indexOf('?');
    const Hindex = handleURL.indexOf('#');
    if (Qindex === -1) {
        if (Hindex === -1 || insertPosition) {
            return handleURL + '?' + qs;
        }
        const isWord = handleURL.match(/(\w)(?=(#.+))/);
        const re = new RegExp((isWord ? '\\b' : '\\B') + '(?=(#.+))');
        return handleURL.replace(re, `?${qs}`);
    }
    return handleURL.replace(/\?\b(?=([\d\D]+=))/, `?${qs}&`);
}
function urlParams(handler = '', url = window.location.href, { afterHash = undefined, merge = true, rebuild = false, remove = [null, undefined, ''] } = {}) {
    if (isString(handler)) {
        return getParams(url, handler);
    }
    if (!isObject(handler)) {
        console.warn('urlParams 添加参数 需要传入object');
        return url;
    }
    // 添加参数
    return pendParams(url, handler, {
        afterHash,
        merge,
        rebuild,
        remove
    });
}
export default urlParams;
